import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, formValueSelector, SubmissionError } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import isEmpty from 'lodash/isEmpty';


import { getAddModalState, getSelectedTabKey, getTabChildrenItem } from '../../../selectors';
import * as actions from '../../../actions';
import * as c from '../../../constants';

import AddItemForm from './AddItemForm';
import AddGroupForm from './AddGroupForm';
import ErrorMessage from './ErrorMessage';
import AddTypeRadioField from '../fields/AddTypeRadioField';

import messages from '../../../translation_hotkey_template';


class AddHotkeyForm extends Component {
  constructor(props) {
    super(props);
    this.handleOnFormSubmit = this.handleOnFormSubmit.bind(this);
  }


  componentDidUpdate(prevProps) {
    const { addType: prevAddType } = prevProps;
    const { addType: currAddType } = this.props;

    if (prevAddType !== currAddType) {
      this.handleOnAddTypeChange(currAddType);
    }
  }


  handleOnAddTypeChange(addType) {
    const { change } = this.props;
    
    const groupType = (addType === c.FORM_ADD_TYPE_GROUP) 
                        ? c.FORM_GROUP_TYPE_CLASS 
                        : c.FORM_GROUP_TYPE_ITEM;

    change('list', null);
    change('group_type', groupType);
  }


  validateForm(form) {
    const { list, group_type } = form;
    const error = [];

    if (isEmpty(list)) {
      const isClass = (group_type === c.FORM_GROUP_TYPE_CLASS);
      error.push(`${isClass ? "Classification" : "Item"} is required.`);
    }

    return isEmpty(error) 
            ? undefined 
            : { _error: error };
  }


  handleOnFormSubmit(form) {
    const error = this.validateForm(form);

    if (error) {
      throw new SubmissionError(error);
    }

    const { mode, addNewChild, addNewTab, resetAddModal } = this.props;

    (mode === c.MODAL_MODE_ADD_CHILD) 
      ? addNewChild(form)
      : addNewTab(form);
    
    resetAddModal();
  }


  render() {
    const { form, mode, addType, excludedItems, pristine, change, error, handleSubmit } = this.props;

    return (
      <div className="ui form basic grid segment ht-marginless" style={{ marginBottom: 5 }}>
        {error &&
          <div className="one column row ht-small-padding">
            <div className="column">
              <ErrorMessage error={error} />
            </div>
          </div>
        }
        <div className="one column row ht-small-padding">
          <div className="column ht-paddingless">
            <AddTypeRadioField 
              label="Add new"
              name="add_type"
              mode={mode}
              translation={{label: { message: messages.label_add_new }}}
            />
          </div>
        </div>
        <div className="one column row ht-small-padding">
          {addType === c.FORM_ADD_TYPE_ITEM && 
            <AddItemForm form={form} change={change} excludedItems={excludedItems} />
          }
          {addType === c.FORM_ADD_TYPE_GROUP &&
            <AddGroupForm form={form} change={change} />
          }        
        </div>
        <div className="one column row ht-paddingless">
          <div className="column ht-small-padding">
            <div className="ui divider ht-paddingless" style={{ paddingBottom: 5 }}></div>
          </div>
        </div>
        <div className="one column row ht-small-padding">
          <div className="column ht-paddingless">
            <div className={`ui primary ${pristine && "disabled"} right floated button`} onClick={handleSubmit(this.handleOnFormSubmit)}><FormattedMessage id="admin.hotkey_template.form.add" defaultMessage="Add" /></div>
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state, { formId: form }) {
  const { mode } = getAddModalState(state);
  const getField = formValueSelector(form);
  const addType = getField(state, 'add_type');
  let excludedItems = [];

  if (
    mode === c.MODAL_MODE_ADD_CHILD
    && addType === c.FORM_ADD_TYPE_ITEM
  ) {
    const key = getSelectedTabKey(state);
    excludedItems = getTabChildrenItem(state, key);
    excludedItems = excludedItems.map(({ item_id }) => item_id);
  }

  return {
    mode,
    form,
    addType,
    excludedItems,
    initialValues: {
      add_type: c.FORM_ADD_TYPE_GROUP,
      group_type: c.FORM_GROUP_TYPE_CLASS,
      list: null
    },
  };
}


function mapDispatchToProps(dispatch) {
  const { addNewChild, addNewTab, resetAddModal } = actions;

  return bindActionCreators({
    resetAddModal,
    addNewChild,
    addNewTab
  }, dispatch);
}


AddHotkeyForm = reduxForm({
  enableReinitialize: true
})(AddHotkeyForm);


export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AddHotkeyForm));
